module.exports = __webpack_public_path__ + "static/img/image11.a9c3a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image11.png
// module id = 84Nz
// module chunks = 0